export default __webpack_public_path__ + "static/media/lipstick-dark-autumn.98b6e510.png";